import { gettext } from '@eventbrite/i18n';
import { css } from 'emotion';
import React from 'react';
import Button from '../../../button/Button';
import Divider from '../../../divider/Divider';

interface IGoToSectionLine {
    goToSection: () => void;
}

const GoToSectionLine = ({
    goToSection,
}: IGoToSectionLine): React.ReactElement => {
    return (
        <div>
            <Divider />

            <div
                data-testid="go-to-section"
                className={css({
                    padding: '16px 16px 0px',
                    float: 'right',
                })}
            >
                <Button onClick={goToSection}>
                    {gettext('Go to section')}
                </Button>
            </div>
        </div>
    );
};

export default GoToSectionLine;
